// HERE WE STORE THE TOKEN OF USER WHICH WE USE TO PASS THROUGH PROTECTED API'S IN ITS HEADER

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userToken: null
}

const userTokenSlice = createSlice({
    name: "userTokenSlice",
    initialState,
    reducers: {
        setUserToken: (state, action) => {
            state.userToken = action.payload;
            return state;
        },
        removeUserToken: (state, action) => {
            state.userToken = null;
            return state;
        }
    }

});

export const { setUserToken, removeUserToken } = userTokenSlice.actions;
export default userTokenSlice.reducer;